/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Composition {
  compositionId?: number;
  compositionName?: string;
  compositionStatusId?: number;
  costTotal?: number;
  dateCreated?: Date;
  dateSyncERP?: Date;
  dateUpdated?: Date;
  description?: string;
  displayTitle?: string;
  editionId?: number;
  glamclubTradeCount?: number;
  invoiceTotal?: number;
  lastboxCount?: number;
  maxInvoiceNumber?: number;
  maxSubscriberCount?: number;
  minInvoiceNumber?: number;
  productVariantCount?: number;
  productVariantId?: number;
  productionGoal?: number;
  saleTotal?: number;
  subscriberCount?: number;
  weightGrams?: number;
}
